import tools from './tools'

var env = 'development'
if (process.env.NODE_ENV === 'development') {
    env = 'development'
} else {
    if (process.env.VUE_APP_TITLE === 'test') {
        env = 'test'
    }
}

let url = '';
let sourceUrl = '';
switch (env) {
    case 'development':
        url = "https://bank-mp.mtdevelop.cn"
        sourceUrl = "https://bank-mp.mtdevelop.cn/"
        break
    case 'test':
        // url = "https://bank-mp.balingmedia.com"
        // sourceUrl = "https://bank-mp.balingmedia.com/"
        break
}
url = url + '/api';
let urlV = 'https://bank-mp.mtdevelop.cn';
// 所有接口
let urlArray = {
    getToken: url + '/system/login', // 获取token
    refreshToken: url + '/system/refresh',// 刷新token
    adminUrl: url + '/system/bstage', // 获取token
    captcha: url + '/system/captcha', // 验证码
    loginOut: url + '/system/logout', // 退出登录

    //common
    usersPassword: url + '/system/users/password', // 修改密码
    orderTotalData: url + '/system/home/totalData', // 统计数据
    //common

    configsShow: url + '/system/configs/show', // 系统配置列表
    configsStore: url + '/system/configs/store', // 添加|编辑系统配置
    configsDestroy: url + '/system/configs/destroy', // 删除系统配置

    dictLoader: (code) => url + `/system/dict/${code}`,

    rolesPermission: url + '/system/roles/permission', // 系统权限列表
    rolesDestroy: url + '/system/roles/destroy', // 删除系统角色
    rolesShow: url + '/system/roles/show', // 系统权限列表
    rolesStore: url + '/system/roles/store', // 系统权限列表

    permissionsShow: url + '/system/permissions/show', // 系统权限列表
    permissionsParsing: url + '/system/permissions/parsing', // 解析未添加路由
    permissionsTree: url + '/system/permissions/tree', // 父级权限列表
    permissionsStore: url + '/system/permissions/store', // 添加|编辑系统权限
    permissionsDestroy: url + '/system/permissions/destroy', // 删除系统权限

    getSide: url + '/system/users/menu', // 侧栏 系统菜单列表
    usersDestroy: url + '/system/users/destroy', // 删除系统权限
    usersAvatar: url + '/system/users/avatar', // 限上传用户头像
    usersShow: url + '/system/users/show', // 系统用户列表
    usersStore: url + '/system/users/store', // 添加|编辑系统角色
    usersRole: url + '/system/users/role', // 系统角色列表

    //员工部门列表
    systemUsersSections: url + '/system/users/sections',

    //系统部门管理
    sectionsTree: url + '/system/section/tree',
    sectionsDestroy: url + '/system/section/destroy',
    sectionsShow: url + '/system/section/show',
    getAllSection: url + '/system/section/getAllSection',
    sectionsStore: url + '/system/section/store',

    //资源分类管理
    cateDestroy: url + '/system/cate/destroy',
    cateShow: url + '/system/cate/show',
    searchSourceCate: url + '/system/cate/searchCate',
    uploadCateThumb: url + '/system/cate/uploadThumb',
    cateStore: url + '/system/cate/store',

    //资源管理
    sourceDestroy: url + '/system/source/destroy',
    sourceShow: url + '/system/source/show',
    sourceStore: url + '/system/source/store',
    sourceThumb: url + '/system/source/uploadThumb',

    //员工管理
    empDestroy: url + '/system/emp/destroy',
    empShow: url + '/system/emp/show',
    empStore: url + '/system/emp/store',
    searchEmp: url + '/system/emp/searchEmp',

    upExcel: url + '/system/emp/upExcel',
    importEmp: url + '/system/emp/importEmp',

    //订单管理
    orderDestroy: url + '/system/order/destroy',
    orderShow: url + '/system/order/show',
    reviewOrder: url + '/system/order/reviewOrder',
    orderChangeOrder: url + '/system/order/changeOrder',
    systemOrderExport: url + '/system/order/export',

    //广告管理
    ggDestroy: url + '/system/gg/destroy',
    ggShow: url + '/system/gg/show',
    ggStore: url + '/system/gg/store',
    ggUploadThumb: url + '/system/gg/uploadThumb',

    //广告位管理
    positionDestroy: url + '/system/position/destroy',
    positionShow: url + '/system/position/show',
    positionStore: url + '/system/position/store',
    ggSearchPosition: url + '/system/gg/searchPosition',

    //文章管理
    articleDestroy: url + '/system/article/destroy',
    articleShow: url + '/system/article/show',
    articleStore: url + '/system/article/store',
    articleUploadThumb: url + '/system/article/uploadThumb',
    articleUploadFile: url + '/system/article/uploadFile',

    //文章分类管理
    artCateDestroy: url + '/system/artCate/destroy',
    artCateShow: url + '/system/artCate/show',
    searchArtCate: url + '/system/artCate/searchArtCate',
    artCateStore: url + '/system/artCate/store',

    //公告管理
    msgDestroy: url + '/system/msg/destroy',
    msgShow: url + '/system/msg/show',
    msgStore: url + '/system/msg/store',
    uploadMsgThumb: url + '/system/msg/uploadMsgThumb',

    //导航管理
    navDestroy: url + '/system/nav/destroy',
    navShow: url + '/system/nav/show',
    navStore: url + '/system/nav/store',

    //部门管理
    sectionDestroy: url + '/system/section/destroy',
    sectionShow: url + '/system/section/show',
    sectionStore: url + '/system/section/store',

    //试卷题目管理
    examquestionShow: url + '/system/examquestion/show',
    examquestionStore: url + '/system/examquestion/store',
    examquestionDestroy: url + '/system/examquestion/destroy',

    //测验结果管理
    examresShow: url + '/system/examres/show',
    examresGetExamResDetail: url + '/system/examres/getExamResDetail',
    examresDestroy: url + '/system/examres/destroy',

    //问券问题管理
    questionTitleShow: url + '/system/questionTitle/show',
    questionTitleStore: url + '/system/questionTitle/store',
    questionTitleDestroy: url + '/system/questionTitle/destroy',
    questionShowQuestion: url + '/system/question/showQuestion',

    //问卷管理管理
    questionShow: url + '/system/question/show',
    questionStore: url + '/system/question/store',
    questionDestroy: url + '/system/question/destroy',
    questionUploadThumb: url + '/system/question/uploadThumb',


    //会员管理
    memberShow: url + '/system/member/show',
    memberDestroy: url + '/system/member/destroy',
    memberExport: url + '/system/member/export',

    //积分商品管理
    goodShow: url + '/system/good/show',
    goodStore: url + '/system/good/store',
    goodDestroy: url + '/system/good/destroy',
    goodUploadThumb: url + '/system/good/uploadThumb',


    examresExamsList: url + '/system/examres/examsList', //获取试卷ID
    // examresExamsList: url + '/system/member/show', //获取会员
    //问券结果管理
    questionResShow: url + '/system/questionRes/show',
    questionResGetQuestionResDetail: url + '/system/questionRes/getQuestionResDetail',
    questionResDestroy: url + '/system/questionRes/destroy',
    questionResShowUser: url + '/system/questionRes/showUser',
    //视频管理
    collectVideoShow: url + '/system/collect/video/show',
    collectVideoDestroy: url + '/system/collect/video/destroy',
    collectVideoCheck: url + '/system/collect/video/check',
    //积分规则
    integralConfigDetail: url + '/integral/config/detail',
    integralConfigStore: url + '/integral/config/store',
    //试卷管理
    examAll: url + '/system/exam/all',
    examShow: url + '/system/exam/show',
    examDestroy: url + '/system/exam/destroy',
    examStore: url + '/system/exam/store',
    commonUploadImage: url + '/common/upload/image',
    //学校管理
    schoolShow: url + '/school/show',
    schoolStore: url + '/school/store',
    schoolDestroy: url + '/school/destroy',
    schoolAll: url + '/school/all',
    //年级管理
    schooClassShow: url + '/school/class/show',
    schooClassAll: url + '/school/class/all',
    schooClassDestroy: url + '/school/class/destroy',
    schooClassStore: url + '/school/class/store',


    tVideoCert: url + '/t/video/cert',
    tVideoTable: url + '/t/video/table',
    tVideoCreate: url + '/t/video/res',
    tVideoUpdate: (id) => url + `/t/video/res/${id}`,
    tVideoRemove: (id) => url + `/t/video/res/${id}`,

    // 打卡地址管理
    bankTable: url + '/bank/table',
    bankStore: url + '/bank/store',
    bankDestroy: url + '/bank/destroy',
}
//所有图片路径
let imgArray = {
    logo: sourceUrl + '/logo.png', // logo路径
}

export default {urlArray, imgArray, url, sourceUrl, urlV}


// cnpm install core-js@2
